import { ActionReducerMap } from "@ngrx/store";
import { InviteUserReducer } from "./invite-user.reducer";
import { InviteUserInternalReducer } from "./invite-user-submit.reducer";

export const InviteReducer: ActionReducerMap<any> = {
    InviteUserData:InviteUserReducer,
    SubmitResponse: InviteUserInternalReducer
};
